import React from 'react';
import './styles/App.css';
import Product from './components/Product';

function App() {
  return (
    <div className='App'>
      <Product />
      <footer>
        <p>R. Raad 2020</p>
      </footer>
    </div>
  );
}

export default App;
